import React, { FC, Fragment } from "react";

import { FormControlLabel as MuiFormControlLabel, makeStyles } from "@material-ui/core";
import { FormControlLabelProps } from "@material-ui/core/FormControlLabel";

import { Colors } from "../../styles";

type Props = FormControlLabelProps & {
    text?: string;
    sublabel?: string;

    error?: boolean;
    isCheckBox?: boolean;
};

const useStyles = makeStyles(() => ({
    root: {
        color: Colors.anthracite,
        marginTop: 16,
    },
    label: {
        marginLeft: 17,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
    },
}));

const useStylesRadio = makeStyles(() => ({
    root: {
        color: Colors.anthracite,
        marginTop: 16,
    },
    label: {
        marginLeft: 8,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
    },
}));

const useErrorStyles = makeStyles(() => ({
    root: {
        color: Colors.radiantRed,
        marginTop: 16,
    },
    label: {
        marginLeft: 17,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
    },
}));

const useErrorStylesRadio = makeStyles(() => ({
    root: {
        color: Colors.radiantRed,
        marginTop: 16,
    },
    label: {
        marginLeft: 8,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
    },
}));

const useInfoTextStyles = makeStyles(() => ({
    root: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 45,
        color: Colors.anthracite50,
        fontStretch: "normal",
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontWeight: 300,
        fontStyle: "normal",
        lineHeight: 1.27,
        letterSpacing: "normal",
    },
}));

const useInfoSublabelStyles = makeStyles(() => ({
    root: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 45,
        color: Colors.anthracite,
        fontStretch: "normal",
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontWeight: 300,
        fontStyle: "normal",
        lineHeight: 1.27,
        letterSpacing: "normal",
    },
}));

export const FormControlLabel: FC<Props> = (props: Props) => {
    const formControlLabelClasses = useStyles({});
    const formControlLabelRadioClasses = useStylesRadio({});
    const formControlLabelErrorClasses = useErrorStyles({});
    const formControlLabelErrorRadioClasses = useErrorStylesRadio({});
    const infoTextClasses = useInfoTextStyles({});
    const infoSublabelClasses = useInfoSublabelStyles({});

    const { error, isCheckBox, ...other } = props;

    return (
        <Fragment>
            <MuiFormControlLabel
                {...other}
                classes={
                    error
                        ? isCheckBox
                            ? formControlLabelErrorClasses
                            : formControlLabelErrorRadioClasses
                        : isCheckBox
                        ? formControlLabelClasses
                        : formControlLabelRadioClasses
                }
            />

            {props.sublabel && (
                <p
                    className={infoSublabelClasses.root}
                    dangerouslySetInnerHTML={{ __html: props.sublabel }}
                ></p>
            )}
            {props.text && (
                <p
                    className={infoTextClasses.root}
                    dangerouslySetInnerHTML={{ __html: props.text }}
                ></p>
            )}
        </Fragment>
    );
};
